// * Write here any validation related code. Use validations.test.ts to test the functions
export var sum = function (a, b) {
    return a + b;
};
export var isMinLength = function (value, minLength) {
    var _a;
    if (minLength === void 0) { minLength = 1; }
    return ((_a = value === null || value === void 0 ? void 0 : value.trim) === null || _a === void 0 ? void 0 : _a.call(value).length) >= minLength;
};
